export const WidgetHeight = {
    xs: '136px',
    sm: '194px',
    md: '292px',
    lg: '447px',
    xl: '603px',
    xxl: '759px'
}